// removed by extract-text-webpack-plugin
module.exports = {"limitStyles":"limitStyles___vH1es"};


//////////////////
// WEBPACK FOOTER
// ./src/vp-ui/components/VpTextLimit/VpTextLimit.module.less
// module id = 2837
// module chunks = 30